import { render, staticRenderFns } from "./EditCaseGroup.vue?vue&type=template&id=6244d748&"
import script from "./EditCaseGroup.vue?vue&type=script&lang=js&"
export * from "./EditCaseGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports